<p-panel class="our-form-background">
  <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
    <h3>
      <span style="margin-left: 15px;"><fa-icon [icon]="['fas', 'user']"> </fa-icon>Training Course Document</span>
    </h3>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="container-fluid" style="margin-top:26px !important;">
      <div class="row">
        <div class="col-12">
          <app-detail-container #docDetailsContainerComponent [containerHeader]="docDetailsContainerHeader"
                                [collapsedContainerHeader]="docDetailsCollapsedContainerHeader"
                                [containerHeaderAction]="docDetailsAction">
            <ng-template #docDetailsContainerHeader>
              Document Details
            </ng-template>
            <ng-template #docDetailsCollapsedContainerHeader>
              <span class="hide-on-small-screens">Document Details - </span>{{trainingTypeDocumentSummary?.originalFilename}}
            </ng-template>
            <ng-template #docDetailsAction>
              <span class="float-right">
                <app-eca-ghost-btn btnText="Preview" btnType="success" btnIcon="search"
                                   *ngIf="trainingTypeDocumentSummary?.canPreviewDocument && !isEditing" [disable]='loading'
                                   (btnClicked)="openTrainingTypeDocument()">
                </app-eca-ghost-btn>
                <app-eca-ghost-btn btnText="Download" btnType="success" btnIcon="download" *ngIf="!isEditing"
                                   (btnClicked)="downloadTrainingTypeDocument()">
                </app-eca-ghost-btn>
                <app-eca-ghost-btn class="title-action-button" *ngIf="!isEditing" btnText="Edit" (btnClicked)="editClicked()" [disable]='loading'
                                   btnIcon="edit" btnType="primary"></app-eca-ghost-btn>
                <app-eca-ghost-btn *ngIf="isEditing" btnText="Save" btnIcon="save" btnType="success"
                                   (btnClicked)="saveTrainingTypeDocumentClicked()" [disable]='loading'></app-eca-ghost-btn>
                <app-eca-ghost-btn *ngIf="isEditing" btnText="Cancel" btnIcon="times" btnType="danger" [disable]='loading'
                                   (btnClicked)="cancelClicked()"></app-eca-ghost-btn>
              </span>
            </ng-template>
            <div class="row">
              <div class="col">
                <div class="container-fluid " style="margin-bottom: 20px">
                  <div *ngIf="loading" class="text-center">
                    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                  </div>
                  <div *ngIf="!loading">
                    <app-document-uploader *ngIf="tempDocumentSummary" [isViewOnly]="!isEditing"
                                           (formStatusChange)="formStatusChange($event)"
                                           (fileRemove)="removeFile($event)"
                                           [submitted]="submitted"
                                           (fileUpload)="fileUploaded($event)"
                                           [documentTypes]="trainingTypeDocumentTypes" [isEditing]="isEditing"
                                           [documentSummary]="tempDocumentSummary"></app-document-uploader>
                  </div>
                </div>
              </div>
            </div>
          </app-detail-container>
        </div>
      </div>
    </div>
    <div class="container-fluid" style="margin-top: 1rem; margin-bottom: 200px; min-height: 400px">
      <div class="row">
        <div class="col">
          <p-tabView #documentTabs [styleClass]="'eca-tabs'">

            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-eye'></i>
                <span class="tab-title">Observations</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <app-observations-list *ngIf="trainingTypeDocumentSummary" [companyId]="companyId" [observations]="trainingTypeDocumentObservations"
                                         [tableTitle]="'Observations'" [showCaption]="true"
                                         [allowedOperations]="loggedInUser?.observationOperations"
                                         (createObservationClicked)="createOrEditObservation($event, true,  'Add Observation for ', ObservationType.CompanyDocument)"
                                         (viewObservationClicked)="createOrEditObservation($event, false, 'Observation for ' )"
                                         (editObservationClicked)="createOrEditObservation($event, false, 'Observation for ' )"></app-observations-list>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </ng-template>
</p-panel>
